import { createSlice } from '@reduxjs/toolkit';

/**
 * AI öneri köprüsü: Assistant drawer'ı bir alanı "uygula" deyince buraya yazar;
 * ilgili wizard step'i bunu okuyup kendi state'ine doldurur, sonra temizler.
 *
 * applied: { title, categories:[{id,label}], features:[{id,label}],
 *            highlights:[...], description, itinerary:[{title,text}] }
 * stamp:   her uygulamada artan sayaç (step'in aynı değeri tekrar uygulamasını tetikler).
 */
export const AiSlice = createSlice({
    name: 'ai',
    initialState: {
        applied: {},
        stamp: 0,
    },
    reducers: {
        applyAi: (state, { payload }) => {
            state.applied[payload.field] = payload.value;
            state.stamp += 1;
        },
        clearAi: (state, { payload }) => {
            if (payload && state.applied[payload] !== undefined) {
                delete state.applied[payload];
            }
        },
        clearAllAi: (state) => {
            state.applied = {};
        },
    },
});

export const { applyAi, clearAi, clearAllAi } = AiSlice.actions;
export const AiReducer = AiSlice.reducer;
